import React, { Component } from "react"
import { connect } from "react-redux"
import { TableHeaderColumn } from "react-bootstrap-table"
import { Button } from "react-bootstrap"
import { DckSelectors, DckActionCreators } from "dck-redux"
import "react-bootstrap-table/dist/react-bootstrap-table.min.css"

import * as ItemTypes from "../../../redux/items/types"
import { browserHistory, Link } from "react-router"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../lib/Authenticated"
import SingleSelectTable from "../../fragments/SingleSelectTable"
import AlertModal from "../../fragments/AlertModal"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import { blockingFetchService } from "../../../lib/blockingFetch"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import CustomBreadCrumb from "../../fragments/CustomBreadCrumb"
import CommissionLogs from "./CommissionLogs"
import ClearFiltersButton from "../../fragments/ClearFiltersButton"
import {
  BooleanStatuses,
  CALCULATION_TYPE,
  selectFiltersFromStore,
  sortDate,
  sortNumber
} from "../../../lib/utils"
import UIAvatar from "../../fragments/UIAvatar"

class ListLoanCommission extends Component {

  authenticated = new Authenticated()
  isAdminOrAccountant = this.authenticated.isAdmin() || this.authenticated.isAccountant()

  state = {
    loanCommission: null,
    running: false,
    success: false,
    error: null,
    showLog: false,
  }

  componentDidMount() {
    this.props.loadData()
  }

  handleDelete = loanCommission => this.setState({ 
    loanCommission,
    running: false,
    success: false,
    error: null
  })

  confirmDelete = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { loanCommission: { id } } = this.state

    blockingFetchService(
      accessToken => apiServerApi.deleteLoanCommission(accessToken, id),
      _ => {
        this.setState({ success: true })
        this.props.loadData()
        setTimeout(this.closeDeleteForm, 1000)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeDeleteForm = () => this.setState({ loanCommission: null })

  doClearFilters = () => {
    this.refs.name.cleanFiltered()
    this.refs.accountToDebitName.cleanFiltered()
    this.refs.accountToCreditName.cleanFiltered()
    this.refs.calculationTypeFormatted.cleanFiltered()
    this.refs.amountFormatted.cleanFiltered()
    this.refs.createdOnFormatted.cleanFiltered()
    this.refs.disabled.cleanFiltered()
  }

  renderDeletionConfirmContent = () => {

    const { running, success, error } = this.state
    return (
      <div>
        <h3>Are you sure you want to delete this item?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderUpdateLink = id => {

    if(!this.isAdminOrAccountant) return null
    return (
      <Link to={`/loancommission/${id}/update`} className='p-5'>
        <FontAwesome name="pencil" title='Update' />
      </Link>
    )
  }

  renderCommissionLogButton = () => {
    if (!this.isAdminOrAccountant) return null
    return <div className="mb-20">
      <Button onClick={() => this.setState({ showLog: true })}
        title="Show Automatic activities log" className="min-w-120">
        <FontAwesome name="info-circle" /> &nbsp; Logs
      </Button>
    </div>
  }

  render() {
    const { loanCommissions, accountToDebitsFilters, accountToCreditsFilters } = this.props,
    { loanCommission, running, showLog } = this.state

    return (
      <div>
        <CustomBreadCrumb activeText='Loan commissions' data={[{ url: '/accounting', title: 'Accounting' }]} />

        <ClearFiltersButton onClick={ this.doClearFilters } />

        <SingleSelectTable
          items={ loanCommissions }
          addNewLabel="Create"
          addNewHandler={() => browserHistory.push("/loancommission/create")}
          handleDelete={ this.handleDelete }
          deleteLabel='Delete'
          disableDelete={() => false}
          shouldRenderToolbar={ this.isAdminOrAccountant }
          exportCSV={ this.isAdminOrAccountant }
          csvFileName='commissions.csv'
        >
          <TableHeaderColumn
            dataField="id"
            isKey
            dataAlign="center"
            dataFormat={(_, row) => <UIAvatar name={ row.name } size={ 28 } />}
            csvHeader="ID"
            width='48'
          />

          <TableHeaderColumn
            ref='name'
            dataField="name"
            dataSort
            filter={{ type: "TextFilter", delay: 1000 }}
            dataAlign="center"
            dataFormat={(value, cell) =>
              <Link to={`/loancommission/${cell.id}/detail`} title='Show details'>
                <span className={ cell.disabled ? 'red' : '' }>{ value }</span>
              </Link>}
            csvHeader="Name"
            columnClassName="min-w-120"
          >
            Name
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='accountToDebitName'
            dataField="accountToDebitName"
            dataSort
            filter={{ type: "SelectFilter", options: accountToDebitsFilters }}
            dataAlign="center"
            csvHeader="Account to debit"
            columnClassName="min-w-120"
          >
            Account to debit
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='accountToCreditName'
            dataField="accountToCreditName"
            dataSort
            filter={{ type: "SelectFilter", options: accountToCreditsFilters }}
            dataAlign="center"
            csvHeader="Account to credit"
            columnClassName="min-w-120"
          >
            Account to credit
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='calculationTypeFormatted'
            dataField="calculationTypeFormatted"
            dataSort
            filter={{ type: "SelectFilter", options: CALCULATION_TYPE }}
            dataAlign="center"
            csvHeader="Calculation type"
            columnClassName="min-w-120"
          >
            Calculation type
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='amountFormatted'
            dataField="amountFormatted"
            dataSort
            sortFunc={(a, b, order) => sortNumber(a.amount, b.amount, order)}
            filter={{ type: "TextFilter", delay: 1000 }}
            dataAlign="center"
            csvHeader="Amount"
            columnClassName="min-w-120"
          >
            Amount
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='createdOnFormatted'
            dataField="createdOnFormatted"
            dataAlign="center"
            dataSort
            sortFunc={(a, b, order) => sortDate(a.createdOn, b.createdOn, order)}
            filter={{ type: "DateFilter", delay: 1000 }}
            csvHeader="Created On"
            columnClassName='text-xs'
            width="140"
          >
            Created On
          </TableHeaderColumn>

          <TableHeaderColumn
            ref='disabled'
            dataField="disabled"
            dataAlign="center"
            dataSort
            width="100px"
            tdStyle={{ verticalAlign: 'middle' }}
            dataFormat={value => value ? <FontAwesome style={{ color: 'green' }} name='check' /> : ''}
            filter={{ type: "SelectFilter", options: BooleanStatuses }}
            csvHeader="Disabled"
          >
            Disabled
          </TableHeaderColumn>

          <TableHeaderColumn
            dataAlign="center"
            width="80px"
            dataFormat={(_, row) =>
            <span className="flex-detail">
              <Link to={`/loancommission/${row.id}/detail`} className='p-5'>
                <FontAwesome name="eye" title='View' />
              </Link>
              { this.renderUpdateLink(row.id) }
            </span>
            }
          />
        </SingleSelectTable>

        { this.renderCommissionLogButton() }

        <AlertModal
          show={ loanCommission != null }
          title="Confirm deletion"
          body={ this.renderDeletionConfirmContent() }
          bsStyle="danger"
          close={ this.closeDeleteForm }
          confirm={ this.confirmDelete }
          proceedText="Delete"
          disabled={ running }
        />

        { showLog && <CommissionLogs show={ showLog } close={() => this.setState({ showLog: false })} /> }
      </div>
    )
  }
}

const mapStateToProps = state => {

  const loanCommissions = DckSelectors.selectAllItems(state, ItemTypes.LoanCommission),
  accountToDebitsFilters = selectFiltersFromStore(state, ItemTypes.AccountToDebitsFilter),
  accountToCreditsFilters = selectFiltersFromStore(state, ItemTypes.AccountToCreditsFilter)

  return { loanCommissions, accountToDebitsFilters, accountToCreditsFilters }
},

mapDispatchToProps = dispatch => ({
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.LoanCommission)),
})

export default connect(mapStateToProps, mapDispatchToProps)(ListLoanCommission)



// WEBPACK FOOTER //
// ./src/components/Accounting/LoanCommission/List.js